import { HelpPageContent } from 'components/help_sidebar';
import { FormattedMessage } from 'react-intl';

const strong = (chunks: React.ReactNode) => (
    <strong>
        {chunks}
    </strong>
);

export const helpContent: HelpPageContent = {
    segments: [
        {
            body: (
                <p>
                    <FormattedMessage defaultMessage="Review orders ready for fulfillment and <strong>process</strong> them to allocate licenses to the requesting partner or customer." id="review_orders_ready_for_fulfillment_and.2231bfcb" values={{ strong }} />
                </p>
            ),
            title: <FormattedMessage defaultMessage="Processing Fulfillment" id="processing_fulfillment.4e68343f" />
        },
        {
            body: (
                <p>
                    <FormattedMessage defaultMessage="Monitor the <strong>fulfillment status</strong> of each order. Fulfilled orders are marked as complete and licenses become available to the recipient." id="monitor_the_fulfillment_status_of_each_o.dcf2b8e8" values={{ strong }} />
                </p>
            ),
            title: <FormattedMessage defaultMessage="Tracking Status" id="tracking_status.2b0249e4" />
        }
    ],
    title: <FormattedMessage defaultMessage="Fulfillment Manager" id="fulfillment_manager.15a3ce36" />
};
